module.exports = require('./lib/Observable.js').Observable;



//////////////////
// WEBPACK FOOTER
// ./~/zen-observable/index.js
// module id = ./node_modules/zen-observable/index.js
// module chunks = 54 55